import * as React from "react";
import { BooleanField, Datagrid, TextField } from "react-admin";
import { CustomDateField } from "../../Components/CustomDateField";
import { EnumField } from "../../../src/Components/EnumField";
import DataGridRowActions from "./DataGridRowActions";
export const DataGridColumns = props => {
  const multiLineProps: any = {
    style: {
      width: "100%",
      whiteSpace: "pre-wrap",
      lineBreak: "anywhere",
    },
    "aria-multiline": "true",
    component: "pre",
  };
  return (
    <Datagrid {...props} optimized hasBulkActions={false}>
      <DataGridRowActions label="Actions" />
      <TextField source="pn" label="Pn" />
      <TextField {...multiLineProps} source="description" label="Pn" />
      <TextField source="spt" label="SPT" />
      <BooleanField source="isAbility" label="Ability Trax" />
      <EnumField label={"Limit Status"} enumName={"AbilityLimitStatus"} source={"limitStatus"} />
      <TextField {...multiLineProps} source="limitNote" label="Limit Note" />
      <TextField source="operationPlace" label="Operation Place" />
      <TextField source="operationPlaceCode" label="Operation Place Code" />
      <TextField {...multiLineProps} source="remarks" label="Remarks" />
      <CustomDateField source="createdDate" label="Created Date" />
    </Datagrid>
  );
};

export default DataGridColumns;
